import React from 'react';

import Tooltip from '../../library/tooltip/tooltip';
import Typography from '../../library/typography/typography';
import PhoneNumber from '../phone-number/phone-number';

import { PRODUCT_TYPES } from '../../shared/constants/products';

import './need-it-now.scss';

interface NeedItNowProps {
  className?: string;
  isPrebuiltPackage?: boolean;
  phone?: string | null;
  productType?: string;
}

function NeedItNow(props: NeedItNowProps) {
  const { className, isPrebuiltPackage, phone, productType } = props;

  if (
    !phone ||
    (productType !== PRODUCT_TYPES.TIRES &&
      productType !== PRODUCT_TYPES.WHEELS &&
      productType !== PRODUCT_TYPES.ACCESSORIES &&
      !isPrebuiltPackage)
  ) {
    return null;
  }

  return (
    <div className={className} data-testid="container" styleName="container">
      <Tooltip
        content={`We can usually get these ${
          (String(productType).toLowerCase() === 'wheels' && 'wheels') ||
          (String(productType).toLowerCase() === 'tires' && 'tires') ||
          'products'
        } even sooner via transfer from a different store or nearby warehouse.`}
        data-testid="content"
      />
      &nbsp;
      <Typography tag="span" weight="heavy">
        Need it now?&nbsp;
      </Typography>
      <Typography tag="span">
        Call store -
        <PhoneNumber isUnformatted phone={phone} styleName="phone" />
      </Typography>
    </div>
  );
}

export default NeedItNow;
